import React from 'react';
import { Box, Image, ResponsiveValue } from '@chakra-ui/react';
import currencyFlagList from '../../CurrencyFlag/currencyFlagsList';

import 'currency-flags/dist/currency-flags.css';

interface CurrencyFlagProps {
  currencyCode: string;
  size?: ResponsiveValue<string | number>;
  borderRadius?: number;
}

export const CurrencyFlag = ({ currencyCode, size = 6, borderRadius = 12 }: CurrencyFlagProps) => {
  return currencyCode && currencyFlagList.includes(currencyCode.toLowerCase()) ? (
    <Box
      w={size}
      h={size}
      borderRadius={borderRadius}
      className={`currency-flag currency-flag-${currencyCode.toLowerCase()}`}
      backgroundPosition="center"
      display="block"
    ></Box>
  ) : (
    <Box w={size}>
      <Image src="default-country-flag.svg" boxSize={size} borderRadius={borderRadius} />
    </Box>
  );
};
